<template>
  <div class="container">
    <div class="index_page">
      <div class="tabs">
        <div>
          <div :class="{'is-active':curP==0}" @click="doCheck(0)">首页</div>
          <div :class="{'is-active':curP==1}" @click="doCheck(1)">样线制作</div>
          <div :class="{'is-active':curP==2}" @click="doCheck(2)">PCBA加工</div>
          <div :class="{'is-active':curP==3}" @click="doCheck(3)">连接器定制</div>
          <div :class="{'is-active':curP==4}" @click="doCheck(4)">主要产品</div>
          <div :class="{'is-active':curP==5}" @click="doCheck(5)">公司简介</div>
        </div>
        <div></div>
        <div id="tab_bar" class="tab_bar"></div>
      </div>
      <div class="section">
        <div class="banner">
          <img :src="imgUrl[currentIndex]" />
        </div>
        <div class="btn">
          <div @mouseenter="stopTimer(0)" @mouseleave="runInv" @click="goJC">
            <div class="btn_text" style="margin-left:64px;">
              <div class="btn_title">样线制作</div>
              <div class="btn_en">Spline Manufacture</div>
            </div>
          </div>
          <div @mouseenter="stopTimer(1)" @mouseleave="runInv" @click="goNB">
            <div class="btn_text" style="margin-left:53px;">
              <div class="btn_title">PCBA加工</div>
              <div class="btn_en">Manufacture of PCBA</div>
            </div>
          </div>
          <div @mouseenter="stopTimer(2)" @mouseleave="runInv" @click="goUPR">
            <div class="btn_text" style="margin-left:49px;">
              <div class="btn_title">连接器定制</div>
              <div class="btn_en">Custom connectors</div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <div>
          <div class="footer_title">
            <div class="line"></div>
            <div>联系我们</div>
          </div>
          <p>
            深圳市德力诚信科技有限公司
            <a
              id="beian"
              href="https://beian.miit.gov.cn/"
              target="_blank"
            >粤ICP备2021152175号-1</a>
          </p>
          <p>公司电话：18116179873</p>
          <p>联系人：刘经理</p>
        </div>
        <div>
          <div class="footer_title">产品中心</div>
          <p>
            <router-link to="/Home/JC">样线制作</router-link>
          </p>
          <p>
            <router-link to="/Home/NB">PCBA加工</router-link>
          </p>
          <p>
            <router-link to="/Home/UPR">连接器定制</router-link>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      curP: 0,
      imgUrl: [
        require("../assets/images/banner1.png"),
        require("../assets/images/banner2.png"),
        require("../assets/images/banner3.png")
      ],
      currentIndex: 0, //默认显示图片
      timer: null //定时器
    };
  },
  created() {
    this.runInv();
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#000");
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    doCheck(i) {
      this.curP = i;
      var tab_bar = document.getElementById("tab_bar");
      if (i == 0) {
        tab_bar.style = "width:24px;transform:translateX(8px)";
        this.goIndex();
      } else if (i == 1) {
        tab_bar.style = "width:48px;transform:translateX(175px)";
        this.goJC();
      } else if (i == 2) {
        tab_bar.style = "width:48px;transform:translateX(381px)";
        this.goNB();
      } else if (i == 3) {
        tab_bar.style = "width:48px;transform:translateX(595px)";
        this.goUPR();
      } else if (i == 4) {
        tab_bar.style = "width:48px;transform:translateX(804px)";
        this.goPro();
      } else if (i == 5) {
        tab_bar.style = "width:48px;transform:translateX(1001px)";
        this.goCallMe();
      }
    },
    goIndex() {
      this.$router.push("/");
    },
    goJC() {
      this.$router.push({ path: "/Home/JC", query: { curP: this.curP } });
    },
    goNB() {
      this.$router.push({ path: "/Home/NB", query: { curP: this.curP } });
    },
    goUPR() {
      this.$router.push({ path: "/Home/UPR", query: { curP: this.curP } });
    },
    goPro() {
      this.$router.push({ path: "/Home/Product", query: { curP: this.curP } });
    },
    goCallMe() {
      this.$router.push({ path: "/Home/CallMe", query: { curP: this.curP } });
    },
    gotoPage(index) {
      this.currentIndex = index;
    },
    stopTimer(index) {
      this.gotoPage(index);
      clearTimeout(this.timer);
    },
    //定时器
    runInv() {
      this.timer = setInterval(() => {
        this.gotoPage(this.nextIndex);
      }, 2000);
    }
  },
  computed: {
    //下一张
    nextIndex() {
      if (this.currentIndex == this.imgUrl.length - 1) {
        return 0;
      } else {
        return this.currentIndex + 1;
      }
    }
  }
};
</script>

<style scoped>
.container {
  color: #fff;
}
/* 轮播 */
.section {
  width: 1200px;
  height: 440px;
  position: relative;
  margin: 0 auto;
}
.banner {
  width: 100%;
  height: 100%;
}
.section .btn {
  width: 1000px;
  margin-left: -500px;
  display: flex;
  position: absolute;
  left: 50%;
  top: 50%;
  margin-left: -500px;
  margin-top: -120px;
  color: #fff;
  text-align: left;
}
.section .btn > div {
  width: 240px;
  height: 240px;
  border: 2px solid #fff;
  border-radius: 50%;
}
.section .btn > div:hover {
  background-color: #000;
  border: 2px solid #000;
  cursor: pointer;
}
.section .btn > div:first-child,
.section .btn > div:nth-child(2) {
  margin-right: 140px;
}
.section .btn .btn_text {
  margin-left: 53px;
}
.section .btn .btn_title {
  font-size: 28px;
  font-weight: 600;
  margin-top: 90px;
  margin-bottom: 2px;
}
.section .btn .btn_en {
  font-size: 14px;
  font-family: Arial-BoldMT, Arial;
  font-weight: normal;
}
/* 页脚 */
.footer {
  margin-top: 36px;
  margin-bottom: -10px;
}
.footer .line {
  background-color: #fff;
}
.footer p,
.footer a {
  color: #fff;
}
</style>